import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { DatePicker, Select } from "antd";
import axios from "axios";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { CREATE_jwel } from "../Config/Config";
import Header from "../Header";
import SidebarDrawer from "../SidebarDrawer";
import styles from "./Accounts.module.css";

const { Option } = Select;

const sections = [
  "Outstanding Customers",
  "Outstanding Dealers",
  "Cash Book",
  "Bank Statement",
  "Receipts Register",
  "Payments Register",
  "Purchase Register",
  "Journal Register",
];

const Accounts = () => {
  const [expanded, setExpanded] = useState([]);
  const [open, setOpen] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [startDate, setStartDate] = useState(dayjs());
  const [endDate, setEndDate] = useState(dayjs());
  const [reStartDate, setReStartDate] = useState(dayjs());
  const [reEndDate, setReEndDate] = useState(dayjs());
  const [payStartDate, setPayStartDate] = useState(dayjs());
  const [payEndDate, setPayEndDate] = useState(dayjs());
  const [purStartDate, setPurStartDate] = useState(dayjs());
  const [purEndDate, setPurEndDate] = useState(dayjs());
  const [jouStartDate, setJouStartDate] = useState(dayjs());
  const [jouEndDate, setJouEndDate] = useState(dayjs());
  const [saleStartDate, setSaleStartDate] = useState(dayjs());
  const [saleEndDate, setSaleEndDate] = useState(dayjs());
  const [areaDropDownCustomer, setAreaDropDownCustomer] = useState([]);
  const [selectAreaCustomer, setSelectAreaCustomer] = useState("");
  const [areaDropDownDealer, setAreaDropDownDealer] = useState([]);
  const [selectAreaDealer, setSelectAreaDealer] = useState("");
  const [dealerData, setDealerData] = useState([]);
  const [customerData, setCustomerData] = useState([]);
  const [cashOpenData, setCashOpenData] = useState(0);
  const [CashBookData, setCashBookData] = useState([]);
  const [totalAmount, setTotalAmount] = useState(0);
  const [accountDropDown, setAccountDropDown] = useState([]);
  const [selectAccount, setSelectAccount] = useState();
  const [accountOpenData, setAccountOpenData] = useState(0);
  const [accountData, setAccountData] = useState([]);
  const [totalAccAmount, setTotalAccAmount] = useState(0);
  const [receiptData, setReceiptData] = useState([]);
  const [totalReceiptAmount, setTotalReceiptAmount] = useState(0);
  const [paymentData, setPaymentData] = useState([]);
  const [totalPaymentAmount, setTotalPaymentAmount] = useState(0);
  const [purchaseData, setPurchaseData] = useState([]);
  const [totalPurchaseAmount, setTotalPurchaseAmount] = useState(0);
  const [journalData, setJournalData] = useState([]);
  const [totalJournalPay, setTotalJournalPay] = useState(0);
  const [totalJournalReceipt, setTotalJournalReceipt] = useState(0);
  const [salesData, setSalesData] = useState([]);
  // const [imagesData, setImagesData] = useState([]);
  // const [userArea, setUserArea] = useState();
  // const [userName, setUserName] = useState();
  // const [singleImage, setSingleImage] = useState();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [totalDues, setTotalDues] = useState(0);
  const [totalDealer, setTotalDealer] = useState(0);

  const imageUrls = localStorage.getItem("images").split(",");
  const imagesData = imageUrls;
  const userArea = localStorage.getItem("city");
  const userName = localStorage.getItem("user");
  const singleImage = localStorage.getItem("singleImage");
  const tenantName = localStorage.getItem("tenantName");

  const toggleDrawer = () => {
    setOpen(false);
  };

  const customerAreaDropDownAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetOutStandingCustForCity`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setAreaDropDownCustomer(data);
      } else {
        setAreaDropDownCustomer([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const dealerAreaDropDownAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetOutStandingDealerForCity`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setAreaDropDownDealer(data);
      } else {
        setAreaDropDownDealer([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const customerAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetOutstandingCustemerData?area=${
          selectAreaCustomer ? selectAreaCustomer : "%"
        }`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setCustomerData(data);
        const totalPay = data.reduce((acc, item) => {
          const jama = Number(item.PAYAMT) || 0;
          return acc + jama;
        }, 0);
        setTotalDues(totalPay);
      } else {
        setCustomerData([]);
        setTotalDues(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const dealerAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetOutstandingDealerData?area=${
          selectAreaDealer ? selectAreaDealer : "%"
        }`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setDealerData(data);
        const totalPay = data.reduce((acc, item) => {
          const jama = Number(item.PAYAMT) || 0;
          return acc + jama;
        }, 0);
        setTotalDealer(totalPay);
      } else {
        setDealerData([]);
        setTotalDealer(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const cashOpeningAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetCashBookOpening?fromDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setCashOpenData(data[0].JAMAAMOUNT - data[0].NAMAAMOUNT);
      } else {
        setCashOpenData(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const cashBookAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetCashBookData?fromDate=${dayjs(
          fromDate,
        ).format("MM/DD/YYYY")}&toDate=${dayjs(toDate).format("MM/DD/YYYY")}`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setCashBookData(data);
        const total = data.reduce((acc, item) => {
          const jama = Number(item.JAMAAMOUNT) || 0;
          const nama = Number(item.NAMAAMOUNT) || 0;
          return acc + (jama - nama);
        }, 0);

        setTotalAmount(total);
      } else {
        setCashBookData([]);
        setTotalAmount(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const accountDropDownAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetBankStatementForAccNo`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setAccountDropDown(data);
      } else {
        setAccountDropDown([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const accountOpeningAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetBankStatementOpening?fromDate=${dayjs(
          startDate,
        ).format("MM/DD/YYYY")}&ledgerName=${selectAccount}`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setAccountOpenData(data[0].NAMAAMOUNT - data[0].JAMAAMOUNT);
      } else {
        setAccountOpenData(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const accountsAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetBankStatementData?fromDate=${dayjs(
          startDate,
        ).format("MM/DD/YYYY")}&toDate=${dayjs(endDate).format(
          "MM/DD/YYYY",
        )}&ledgerName=${selectAccount}`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setAccountData(data);
        const total = data.reduce((acc, item) => {
          const jama = Number(item.JAMAAMOUNT) || 0;
          const nama = Number(item.NAMAAMOUNT) || 0;
          return acc + (nama - jama);
        }, 0);

        setTotalAccAmount(total);
      } else {
        setAccountData([]);
        setTotalAccAmount(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const receiptRegisterAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetReceiptRegForData?fromDate=${dayjs(
          reStartDate,
        ).format("MM/DD/YYYY")}&toDate=${dayjs(reEndDate).format(
          "MM/DD/YYYY",
        )}&street=%&custName=%`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setReceiptData(data);
        const total = data.reduce((acc, item) => {
          const jama = Number(item.paidamt) || 0;
          return acc + jama;
        }, 0);

        setTotalReceiptAmount(total);
      } else {
        setReceiptData([]);
        setTotalReceiptAmount(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const paymentRegisterAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetPatymentRegisterData?fromDate=${dayjs(
          payStartDate,
        ).format("MM/DD/YYYY")}&toDate=${dayjs(payEndDate).format(
          "MM/DD/YYYY",
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setPaymentData(data);
        const total = data.reduce((acc, item) => {
          const jama = Number(item.Paid) || 0;
          return acc + jama;
        }, 0);

        setTotalPaymentAmount(total);
      } else {
        setPaymentData([]);
        setTotalPaymentAmount(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const purchaseRegisterAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetPurchaseRegForData?fromDate=${dayjs(
          purStartDate,
        ).format("MM/DD/YYYY")}&toDate=${dayjs(purEndDate).format(
          "MM/DD/YYYY",
        )}&hid=0`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setPurchaseData(data);
        const total = data.reduce((acc, item) => {
          const jama = Number(item.netamt) || 0;
          return acc + jama;
        }, 0);

        setTotalPurchaseAmount(total);
      } else {
        setPurchaseData([]);
        setTotalPurchaseAmount(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const journalRegisterAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetDataFromGivenTableNameWithWhereandOrder?tableName=DAY_TRANSACTIONS&where=SDATE>='${dayjs(
          jouStartDate,
        ).format("MM/DD/YYYY")}' and SDATE<='${dayjs(jouEndDate).format(
          "MM/DD/YYYY",
        )}'&order=VNO`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setJournalData(data);
        const totalPay = data.reduce((acc, item) => {
          const jama = Number(item.DEBIT_PAYMENT) || 0;
          return acc + jama;
        }, 0);

        const totalReceipt = data.reduce((acc, item) => {
          const jama = Number(item.CREDIT_RECEIPT) || 0;
          return acc + jama;
        }, 0);

        setTotalJournalPay(totalPay);
        setTotalJournalReceipt(totalReceipt);
      } else {
        setJournalData([]);
        setTotalJournalPay(0);
        setTotalJournalReceipt(0);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  const salesMenAPI = async () => {
    try {
      const response = await axios.get(
        `${CREATE_jwel}/api/ERP/GetSMCommissionDetails?billStartDate=${dayjs(
          saleStartDate,
        ).format("MM/DD/YYYY")}&billEndDate=${dayjs(saleEndDate).format(
          "MM/DD/YYYY",
        )}`,
        {
          headers: {
            tenantName: tenantName,
          },
        },
      );

      const data = response.data;

      if (Array.isArray(data) && data.length > 0) {
        setSalesData(data);
      } else {
        setSalesData([]);
      }
    } catch (error) {
      console.error("Error fetching estimation count:", error);
    }
  };

  // const userAPI = async () => {
  //   try {
  //     const response = await axios.get(
  //       `${CREATE_jwel}/api/ERP/GetDataFromGivenTableName?tableName=FIRM_CONFIGURE`,
  //       {
  //         headers: {
  //           tenantName: tenantName,
  //         },
  //       }
  //     );

  //     const data = response.data;

  //     if (Array.isArray(data) && data.length > 0) {
  //       const imageUrls = data[0]?.EPASS1.split(",");
  //       setImagesData(imageUrls);
  //       setUserName(data[0]?.FIRMNAME);
  //       setUserArea(data[0]?.CITY);
  //       setSingleImage(data[0]?.EPASS2);
  //     }
  //   } catch (error) {
  //     console.error("Error fetching estimation count:", error);
  //   }
  // };

  useEffect(() => {
    customerAreaDropDownAPI();
    customerAPI();
  }, [selectAreaCustomer]);

  useEffect(() => {
    dealerAreaDropDownAPI();
    dealerAPI();
  }, [selectAreaDealer]);

  useEffect(() => {
    cashOpeningAPI();
    cashBookAPI();
  }, [fromDate, toDate]);

  useEffect(() => {
    accountDropDownAPI();
    accountOpeningAPI();
    accountsAPI();
  }, [selectAccount, startDate, endDate]);

  useEffect(() => {
    receiptRegisterAPI();
  }, [reStartDate, reEndDate]);

  useEffect(() => {
    paymentRegisterAPI();
  }, [payStartDate, payEndDate]);

  useEffect(() => {
    purchaseRegisterAPI();
  }, [purStartDate, purEndDate]);
  useEffect(() => {
    journalRegisterAPI();
  }, [jouStartDate, jouEndDate]);

  useEffect(() => {
    salesMenAPI();
    // userAPI();
  }, [saleStartDate, saleEndDate]);

  const handleExpandAll = () => {
    setExpanded("all");
    customerAreaDropDownAPI();
    customerAPI();
    dealerAreaDropDownAPI();
    dealerAPI();
    cashOpeningAPI();
    cashBookAPI();
    accountDropDownAPI();
    accountOpeningAPI();
    accountsAPI();
    receiptRegisterAPI();
    paymentRegisterAPI();
    purchaseRegisterAPI();
    journalRegisterAPI();
    salesMenAPI();
  };

  const handleCollapseAll = () => {
    setExpanded(null);
  };

  const handleChange = (panel) => {
    setExpanded((prev) => (prev === panel ? null : panel));
  };

  useEffect(() => {
    if (!selectAccount && accountDropDown.length > 0) {
      setSelectAccount(accountDropDown[0].AccNo);
    }
  }, [accountDropDown, selectAccount]);

  useEffect(() => {
    if (imagesData.length > 1) {
      const interval = setInterval(() => {
        setCurrentIndex((prev) => (prev + 1) % imagesData.length);
      }, 1500);
      return () => clearInterval(interval);
    }
  }, [imagesData]);

  return (
    <div>
      <Header setOpen={setOpen} />
      <SidebarDrawer
        open={open}
        toggleDrawer={toggleDrawer}
        singleImage={singleImage}
        userArea={userArea}
        userName={userName}
      />
      <div className={styles.carouselContainer}>
        <div
          className={styles.carouselSlider}
          style={{
            transform: `translateX(-${currentIndex * 33.33}%)`,
            width: `${imagesData.length * 100}%`,
          }}
        >
          {imagesData.map((src, index) => (
            <img
              key={index}
              src={src}
              alt={`img-${index}`}
              className={styles.carouselImage}
            />
          ))}
        </div>
      </div>
      <div className={styles.container}>
        <div className={styles.headerContainer}>
          <h3 className={styles.heading}>Accounts</h3>

          <div className={styles.buttonRow}>
            <button
              variant="outlined"
              type="default"
              className={styles.expandButton}
              onClick={handleExpandAll}
            >
              Expand All +
            </button>
            <button
              variant="outlined"
              type="default"
              className={styles.collapseButton}
              onClick={handleCollapseAll}
            >
              Collapse All -
            </button>
          </div>
        </div>
        <div style={{ marginBottom: "5px", marginTop: "15px" }}>
          <Accordion
            expanded={expanded === "panel1" || expanded === "all"}
            onChange={() => {
              handleChange("panel1");
              customerAreaDropDownAPI();
              customerAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Outstanding Customers
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                  fontSize: "12px",
                  marginLeft: "10px",
                  backgroundColor:
                    expanded === "panel1" || expanded === "all"
                      ? "white"
                      : "#52bd91",
                  color:
                    expanded === "panel1" || expanded === "all"
                      ? "#52bd91"
                      : "black",
                  padding: "8px 10px 5px 10px",
                  borderRadius: "8px",
                }}
              >
                {/* Pending Dues:{" "} */}
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color:
                      expanded === "panel1" || expanded === "all"
                        ? "white"
                        : "red",
                    color:
                      expanded === "panel1" || expanded === "all"
                        ? "red"
                        : "black",
                  }}
                >
                  {"₹" + totalDues?.toFixed(2)}
                </span>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel1" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel1" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div style={{ minWidth: "100px", fontWeight: "bold" }}>
                  Select Area:
                </div>
                <Select
                  allowClear
                  showSearch={false}
                  placeholder="Select Area"
                  style={{ width: "70%" }}
                  value={selectAreaCustomer || undefined}
                  onChange={(value) => {
                    setSelectAreaCustomer(value); // value will be `undefined` when cleared
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const filteredOptions = areaDropDownCustomer.filter(
                        (area) =>
                          area.AREA.toLowerCase().includes(
                            e.target.value.toLowerCase(),
                          ),
                      );
                      if (filteredOptions.length > 0) {
                        setSelectAreaCustomer(filteredOptions[0].AREA);
                      }
                    }
                  }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {areaDropDownCustomer.map((area, index) => (
                    <Option key={index} value={area.AREA}>
                      {area.AREA}
                    </Option>
                  ))}
                </Select>
              </div>
              {customerData.map((customer, index) => (
                <div
                  key={customer.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      City:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {customer.AREA}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Customer Name:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {customer.PARTYNAME}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {customer.PAYAMT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel2" || expanded === "all"}
            onChange={() => {
              handleChange("panel2");
              dealerAreaDropDownAPI();
              dealerAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Outstanding Dealers
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginLeft: "10px",
                  fontSize: "12px",
                  marginLeft: "10px",
                  backgroundColor:
                    expanded === "panel2" || expanded === "all"
                      ? "white"
                      : "#52bd91",
                  color:
                    expanded === "panel2" || expanded === "all"
                      ? "#52bd91"
                      : "black",
                  padding: "8px 10px 5px 10px",
                  borderRadius: "8px",
                }}
              >
                {/* Pending Dues:{" "} */}
                <span
                  style={{
                    fontWeight: "bold",
                    fontSize: "14px",
                    color:
                      expanded === "panel2" || expanded === "all"
                        ? "white"
                        : "red",
                    color:
                      expanded === "panel2" || expanded === "all"
                        ? "red"
                        : "black",
                  }}
                >
                  {"₹" + totalDealer?.toFixed(2)}
                </span>
              </div>
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel2" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel2" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div style={{ minWidth: "100px", fontWeight: "bold" }}>
                  Select Area:
                </div>
                <Select
                  allowClear
                  showSearch={false}
                  placeholder="Select Area"
                  style={{ width: "70%" }}
                  value={selectAreaDealer || undefined}
                  onChange={(value) => {
                    setSelectAreaDealer(value); // value will be `undefined` when cleared
                  }}
                  onKeyDown={(e) => {
                    if (e.key === "Enter") {
                      const filteredOptions = areaDropDownDealer.filter(
                        (area) =>
                          area.AREA.toLowerCase().includes(
                            e.target.value.toLowerCase(),
                          ),
                      );
                      if (filteredOptions.length > 0) {
                        setSelectAreaDealer(filteredOptions[0].AREA);
                      }
                    }
                  }}
                  filterOption={(input, option) =>
                    option.children.toLowerCase().includes(input.toLowerCase())
                  }
                >
                  {areaDropDownDealer.map((area, index) => (
                    <Option key={index} value={area.AREA}>
                      {area.AREA}
                    </Option>
                  ))}
                </Select>
              </div>
              {dealerData.map((dealer, index) => (
                <div
                  key={dealer.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      City:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dealer.AREA}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Dealer Name:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dealer.PARTYNAME}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {dealer.PAYAMT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel3" || expanded === "all"}
            onChange={() => {
              handleChange("panel3");
              cashOpeningAPI();
              cashBookAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Cash Book
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel3" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel3" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div className={styles.dateFilters}>
                <DatePicker
                  value={fromDate}
                  onChange={setFromDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={toDate}
                  onChange={setToDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Cash Opening:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {cashOpenData?.toFixed(2)}
                  </span>
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Closing Cash:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {(cashOpenData - totalAmount).toFixed(2)}
                  </span>
                </span>
              </div>

              {CashBookData.map((cash, index) => (
                <div
                  key={cash.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      {/* VNO:{" "} */}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {cash.VNO}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {cash.PARTICULARS}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {cash.TRANS_TYPE}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(cash?.ENTRYDATE).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {(cash.JAMAAMOUNT - cash.NAMAAMOUNT).toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel4" || expanded === "all"}
            onChange={() => {
              handleChange("panel4");
              accountDropDownAPI();
              accountOpeningAPI();
              accountsAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel4" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel4" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Bank Statement
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel4" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel4" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <div style={{ minWidth: "60px", fontWeight: "bold" }}>
                  Select Acc:
                </div>
                <Select
                  allowClear
                  showSearch={false} // Disable manual typing
                  placeholder="Select Acc"
                  style={{ width: "70%" }}
                  value={selectAccount || undefined}
                  onChange={(value) => {
                    setSelectAccount(value);
                  }}
                >
                  {accountDropDown.map((acc, index) => (
                    <Option key={index} value={acc.AccNo}>
                      {acc.AccNo}
                    </Option>
                  ))}
                </Select>
              </div>
              <div className={styles.dateFilters}>
                <DatePicker
                  value={startDate}
                  onChange={setStartDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={endDate}
                  onChange={setEndDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Cash Opening:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {accountOpenData?.toFixed(2)}
                  </span>
                </span>
              </div>

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Closing Cash:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {(accountOpenData - totalAccAmount).toFixed(2)}
                  </span>
                </span>
              </div>

              {accountData.map((cash, index) => (
                <div
                  key={cash.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      {/* VNO:{" "} */}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {cash.VNO}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {cash.PARTICULARS}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {cash.TRANS_TYPE}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {cash.SALESTYPE}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(cash?.ENTRYDATE).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {(cash.NAMAAMOUNT - cash.JAMAAMOUNT).toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel5" || expanded === "all"}
            onChange={() => {
              handleChange("panel5");
              receiptRegisterAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel5" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel5" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Receipt Register
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel5" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel5" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div className={styles.dateFilters}>
                <DatePicker
                  value={reStartDate}
                  onChange={setReStartDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={reEndDate}
                  onChange={setReEndDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Total Amount:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {totalReceiptAmount?.toFixed(2)}
                  </span>
                </span>
              </div>
              {receiptData.map((receipt, index) => (
                <div
                  key={receipt.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Rec No:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {receipt.RecNo}
                      </span>
                    </span>
                    <span>
                      Rec Date:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(receipt?.RecDate).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {receipt.Street}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {receipt.custname}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {receipt.paidamt.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel6" || expanded === "all"}
            onChange={() => {
              handleChange("panel6");
              paymentRegisterAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel6" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel6" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Payment Register
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel6" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel6" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div className={styles.dateFilters}>
                <DatePicker
                  value={payStartDate}
                  onChange={setPayStartDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={payEndDate}
                  onChange={setPayEndDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Total Amount:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {totalPaymentAmount?.toFixed(2)}
                  </span>
                </span>
              </div>
              {paymentData.map((payment, index) => (
                <div
                  key={payment.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      VNO:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {payment.receiptno}
                      </span>
                    </span>
                    <span>
                      Date:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(payment?.receiptdate).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {payment.Area}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {payment.custname}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Amount:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {payment.Paid.toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel7" || expanded === "all"}
            onChange={() => {
              handleChange("panel7");
              purchaseRegisterAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel7" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel7" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Purchase Register
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel7" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel7" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div className={styles.dateFilters}>
                <DatePicker
                  value={purStartDate}
                  onChange={setPurStartDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={purEndDate}
                  onChange={setPurEndDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Total Net Amount:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {totalPurchaseAmount?.toFixed(2)}
                  </span>
                </span>
              </div>
              {purchaseData.map((purchase, index) => (
                <div
                  key={purchase.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Inv No:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {purchase.INVNO}
                      </span>
                    </span>
                    <span>
                      Inv Date:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(purchase?.INVDATE).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Entry No:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {purchase.ENTRYNO}
                      </span>
                    </span>
                    <span>
                      Entry Date:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(purchase?.ENTRYDATE).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {purchase.Area}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {purchase.partyname}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "flex-start",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Gross:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        {"₹" + purchase.grossamt.toFixed(2)}
                      </span>
                    </span>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "flex-end",
                      }}
                    >
                      <span>
                        GST(%):{" "}
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {"₹" + purchase.vatamt.toFixed(2)}
                        </span>
                      </span>
                      <span>
                        Net:{" "}
                        <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                          {"₹" + purchase.netamt.toFixed(2)}
                        </span>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel8" || expanded === "all"}
            onChange={() => {
              handleChange("panel8");
              journalRegisterAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel8" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel8" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Journal Register
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel8" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel8" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div className={styles.dateFilters}>
                <DatePicker
                  value={jouStartDate}
                  onChange={setJouStartDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={jouEndDate}
                  onChange={setJouEndDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Total Pay:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {totalJournalPay?.toFixed(2)}
                  </span>
                </span>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  fontSize: "14px",
                  color: "#555",
                  backgroundColor: "#f0f0f0",
                  borderRadius: "8px",
                  padding: "10px",
                  boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                  marginBottom: "10px",
                }}
              >
                <span>
                  Total Receipt:
                  <span
                    style={{
                      fontSize: "16px",
                      fontWeight: "bold",
                      marginLeft: "10px",
                    }}
                  >
                    ₹ {totalJournalReceipt?.toFixed(2)}
                  </span>
                </span>
              </div>
              {journalData.map((journal, index) => (
                <div
                  key={journal.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      VNO:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {journal.VNO}
                      </span>
                    </span>
                    <span>
                      Date:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {dayjs(journal?.SDATE).format("DD-MMM-YYYY")}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {journal.LEDGERNAME}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "12px",
                        }}
                      >
                        {journal.TYPE}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Pay:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {Number(journal.DEBIT_PAYMENT).toFixed(2)}
                      </span>
                    </span>
                    <span>
                      Receipt:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        ₹ {Number(journal.CREDIT_RECEIPT).toFixed(2)}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
        <div style={{ marginBottom: "5px" }}>
          <Accordion
            expanded={expanded === "panel9" || expanded === "all"}
            onChange={() => {
              handleChange("panel9");
              salesMenAPI();
            }}
            style={{ border: "1px solid #52bd91" }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              style={{
                fontWeight: "bold",
                fontSize: "14px",
                backgroundColor:
                  expanded === "panel9" || expanded === "all"
                    ? "#52bd91"
                    : "#d6d6d6",
                color:
                  expanded === "panel9" || expanded === "all"
                    ? "white"
                    : "black",
              }}
            >
              Sales Men Wise Commission
            </AccordionSummary>
            <AccordionDetails
              style={{
                backgroundColor:
                  expanded === "panel9" || expanded === "all"
                    ? "#d9d9d9"
                    : "#d6d6d6",
                color:
                  expanded === "panel9" || expanded === "all"
                    ? "black"
                    : "black",
                maxHeight: "300px",
                overflowY: "auto",
              }}
            >
              <div className={styles.dateFilters}>
                <DatePicker
                  value={saleStartDate}
                  onChange={setSaleStartDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
                <DatePicker
                  value={saleEndDate}
                  onChange={setSaleEndDate}
                  className={styles.datePicker}
                  inputReadOnly
                  format="DD-MMM-YYYY"
                  maxDate={dayjs()}
                  disabledDate={(current) =>
                    current && current > dayjs().endOf("day")
                  }
                />
              </div>
              {salesData.map((sale, index) => (
                <div
                  key={sale.id}
                  style={{
                    background:
                      "radial-gradient(circle at center, #ffffff 40%, #f3f6fb 60%, #e0e7f1 80%)",
                    marginBottom: "8px",
                    padding: "10px",
                    borderRadius: "8px",
                    boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                    border: "1px solid #52bd91",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      SM.Code:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {sale.SMCode}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      QTY:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {Number(sale.QTY)?.toFixed(0)}
                      </span>
                    </span>
                    <span>
                      Amount:{" "}
                      <span
                        style={{
                          color: "#162566",
                          fontWeight: "bold",
                          fontSize: "16px",
                        }}
                      >
                        {"₹" + sale.AMOUNT.toFixed(2)}
                      </span>
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      fontSize: "14px",
                      color: "#555",
                      backgroundColor: "#f0f0f0",
                      borderRadius: "8px",
                      padding: "10px",
                      boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                      marginBottom: "10px",
                    }}
                  >
                    <span>
                      Sale.Comm:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        {sale.COMM.toFixed(2)}
                      </span>
                    </span>
                    <span>
                      Token:{" "}
                      <span style={{ fontSize: "16px", fontWeight: "bold" }}>
                        {sale.TOKEN}
                      </span>
                    </span>
                  </div>
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
      </div>
    </div>
  );
};

export default Accounts;
